/**
 * @file 扩展插件
 * @author WangZhuang
 */
/* globals shareConfig */
import axios from 'axios';
import {Component} from 'react';
import qs from 'query-string';

export function rcAjax(type, url, param, data, callback) {
    return axios({
        method: type,
        url: url,
        params: param,
        data: data
    })
        .then(response => {
            callback(response);
            return response;
        })
        .catch(error => {
            callback(error.response);
        });
}

export function bAntiBotSend() {
    if (window.BCat_2024 && window.BCat_2024.miao) {
        window.BCat_2024.miao();
    } else if (window.BAntiBot && window.BAntiBot.send) {
        window.BAntiBot.send();
    }
}

export const thunkMiddleware = ({dispatch, getState}) => next => action => {
    if (Object.prototype.toString.call(action) === '[object Function]') {
        return action(dispatch, getState);
    }

    return next(action);
};

(function (designWidth, maxWidth) { // 淘宝移动端的rem计算方式
    let doc = document;
    let win = window;
    let docEl = doc.documentElement;
    let metaEl;
    let metaElCon;
    let remStyle = document.createElement('style');
    let tid;

    function refreshRem() {
        // var width = parseInt(window.screen.width)
        let width = docEl.getBoundingClientRect().width;
        if (!maxWidth) {
            maxWidth = 540;
        }
        if (width > maxWidth) { // 限制在540的屏幕下，这样100%就跟10rem不一样了
            width = maxWidth;
        }
        let rem = width * 100 / designWidth;
        // var rem = width / 10; // 如果要兼容vw的话分成10份
        // docEl.style.fontSize = rem + "px";
        // 旧的做法，在uc浏览器下面会有切换横竖屏时定义了font-size的标签不起作用的bug
        remStyle.innerHTML = 'html{font-size:' + rem + 'px;}';
    }

    // 设置 viewport ，有的话修改 没有的话设置
    metaEl = doc.querySelector('meta[name="viewport"]');
    // 20171219修改：增加 viewport-fit=cover ，用于适配iphoneX
    metaElCon = 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=no,viewport-fit=cover';
    if (metaEl) {
        metaEl.setAttribute('content', metaElCon);
    } else {
        metaEl = doc.createElement('meta');
        metaEl.setAttribute('name', 'viewport');
        metaEl.setAttribute('content', metaElCon);
        if (docEl.firstElementChild) {
            docEl.firstElementChild.appendChild(metaEl);
        } else {
            let wraps = doc.createElement('div');
            wraps.appendChild(metaEl);
            doc.write(wraps.innerHTML);
            wraps = null;
        }
    }

    // 要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
    refreshRem();

    if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(remStyle);
    } else {
        let wrap = doc.createElement('div');
        wrap.appendChild(remStyle);
        doc.write(wrap.innerHTML);
        wrap = null;
    }

    win.addEventListener('resize', function () {
        clearTimeout(tid); // 防止执行两次
        tid = setTimeout(refreshRem, 300);
    }, false);

    win.addEventListener('pageshow', function (e) {
        if (e.persisted) { // 浏览器后退的时候重新计算
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
        }
    }, false);
})(1080, 1080);

export function extendComponent() {
    return function () {
        Component.prototype.isEmptyobj = function (obj) { // 判断是否为空对象
            for (let key in obj) {
                return false;
            }
            return true;
        };

        Component.prototype.isTest = function () { // 判断是否为测试线
            let reg = new RegExp('(localhost|127.0.0.1|test.anquan.baidu.com|cq02-security-dev01.cq02.baidu.com)');
            let res = reg.test(location.host);
            return res;
        };

        Component.prototype.isPC = function () { // 判断是否为PC端
            if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
                return false;
            } else {
                return true;
            }
        };

        Component.prototype.isPhone = function (val) { // 判断是否为手机号
            let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            let value = val.replace(/\s/g, '');
            return reg.test(value);
        };

        Component.prototype.isIos = function () { // 判断是否为ios端
            return navigator.userAgent.match(/(iPhone|iPod|ios)/i);
        };

        Component.prototype.isAndroid = function () { // 判断是否为Android端
            return navigator.userAgent.match(/(Android)/i);
        };

        Component.prototype.isSafari = function () { // 判断是否为Safari
            const ua = navigator.userAgent;
            // IOS系统
            if (/ OS \d/.test(ua)) {
                // 不是Chrome
                if (!~ua.indexOf('CriOS')) {
                    // 开头必须为Mozilla
                    if (!ua.indexOf('Mozilla')) {
                        // 结尾需为：Safari/xxx.xx
                        if (/Safari\/[\d\\.]+$/.test(ua)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        Component.prototype.getRequest = function () {
            let url = location.search; // 获取url中"?"符后的字串
            let theRequest = {};
            if (url.indexOf('?') !== -1) {
                let str = url.substr(1);
                let strs = str.split('&');
                for (let i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
                }
            }
            return theRequest;
        };

        Component.prototype.shareWX = function (obj) {
            let json = {
                debug: location.href.indexOf('share_debug=1') > 0,
                title: '百度安全社区-有AI更安全',
                contentDefault: '百度安全',
                linkUrl: `https://anquan.baidu.com${location.pathname}`,
                iconUrl: 'https://anquan.baidu.com/bdaq.jpg',
                iconUrlDefault: 'https://anquan.baidu.com/bdaq.jpg',
                bdbox: {
                    source: 'feednews'
                },
                wx: {
                    appId: 'wxadc1a0c6b9096e89',
                    jsApiList: []
                }
            };

            for (let attr in obj) {
                json[attr] = obj[attr];
            }

            shareConfig.init(json);
        };

        Component.prototype.formatTime = function (time) {
            let d = time / 60 / 60 / 24 / 1000;
            if (d === 365) {
                return '1年';
            } else if (d === 30) {
                return '1月';
            } else {
                return d + '天';
            }
        };

        Component.prototype.isDev = function () {
            let reg = new RegExp('(localhost|localtest.baidu.com|127.0.0.1'
                + '|test.anquan.baidu.com|yq01-security)');
            return reg.test(location.host); // 判断是否为测试线
        };


        Component.prototype.loginUrl = function (url) {
            const curUrl = encodeURIComponent(url ? (location.origin + url) : location.href);

            // return this.isDev()
            //     ? `//wappass.qatest.baidu.com?tpl=spu&subpro=spuuser&u=${curUrl}`
            //     : `//wappass.baidu.com?tpl=spu&subpro=spuuser&u=${curUrl}`;

            return '/m/login?urlto=' + encodeURIComponent(curUrl);
        };

        Component.prototype.userCenterUrl = function (url) {
            const curUrl = encodeURIComponent(url ? (location.origin + url) : location.href);
            return this.isDev()
                ? `//wappass.qatest.baidu.com/wp/v3/ucenter/realnameverify?tpl=spu&adapter=&client=&okU=${curUrl}`
                : `//wappass.baidu.com/wp/v3/ucenter/realnameverify?tpl=spu&adapter=&client=&okU=${curUrl}`;
        };

        Component.prototype.getParams = function () {
            const search = (window.location.search || '').split('?')[1];

            return qs.parse(search);
        };

        Component.prototype.isPageTitle = function isPageTitle(string, text) {
            return (text || '').toLowerCase().indexOf(string) > -1;
        };

        Component.prototype.reportAjax = function reportData(channel, responseData) {
            if (!responseData) {
                return;
            }
            try {
                const companyJson = {
                    channel: channel,
                    event: 'click'
                };
                const localData = JSON.parse(responseData);
                if (localData && localData.data) {
                    companyJson.data = localData.data;
                }
                if (localData && localData.key_id) {
                    companyJson['key_id'] = localData['key_id'];
                }
                if (localData && localData.sign) {
                    companyJson.sign = localData.sign;
                }

                axios({
                    url: '/xiapi/api/v1/activity/reportData',
                    method: 'POST',
                    data: companyJson
                });
            } catch (e) {
                return;
            }
        };

        Component.prototype.reportData = function reportData(channel, disabledSendMessage) {
            try {
                if (!disabledSendMessage) {
                    bAntiBotSend();
                }
                const that = this;
                window['__abbaidu_2024_cb'] = function (responseData) {
                    that.reportAjax(channel, responseData);
                };
            } catch (e) {
                return;
            }
        };
    };
}



// WEBPACK FOOTER //
// ./src/util.js